.FAQGroup {
  display: none;
  justify-content: space-between;
  gap: var(--brand-stack-gap-spacious);
}

.FAQGroup__accordion {
  margin-block-start: var(--base-size-48);
}

.FAQGroup__panel-subHeading {
  margin-block-start: calc(var(--base-size-8) + 1px);
  text-transform: uppercase;
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
}

.FAQGroup__tablist .FAQ__heading {
  display: none;
}

.FAQGroup__tablist-button {
  appearance: none;
  border: none;
  background-color: transparent;
  padding-block: var(--base-size-8);
  padding-inline: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--base-size-12);
  width: 100%;
  font-family: var(--brand-fontStack-monospace);
  font-size: var(--brand-text-size-100);
  font-weight: var(--brand-text-weight-500);
  line-height: var(--brand-text-lineHeight-100);
  letter-spacing: 0.15px;
  text-transform: uppercase;
  text-align: start;
  color: var(--brand-color-text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: gap var(--brand-animation-duration-fast) var(--brand-animation-easing-default);
}

.FAQGroup__tablist-button:focus-visible {
  outline: var(--brand-borderWidth-thick) solid var(--brand-color-focus);
  outline-offset: 2px;
}

.FAQGroup__tablist-button::before {
  content: '';
  display: block;
  width: calc(var(--base-size-8) + var(--base-size-2));
  height: var(--base-size-12);
  flex-shrink: 0;
  background-color: var(--brand-FAQGroup-buttonIndicator-idle);
  transform: scaleX(0.7);
  transform-origin: left;
  transition: transform var(--brand-animation-duration-fast) var(--brand-animation-easing-default),
    background-color var(--brand-animation-duration-fast) var(--brand-animation-easing-default);
}

.FAQGroup__tablist-button:hover::before {
  background-color: var(--brand-FAQGroup-buttonIndicator-hover);
}

.FAQGroup__tablist-button[aria-selected='true'] {
  color: var(--brand-FAQ-color-tabLabel-selected);
  gap: calc(var(--base-size-12) + 3px);
}

.FAQGroup__tablist-button[aria-selected='true']::before {
  transform: scaleX(1);
  background-color: var(--brand-FAQGroup-buttonIndicator-active);
}

.FAQGroup__nested-accordion-item summary h4 {
  font-weight: var(--brand-text-weight-200);
  font-size: var(--brand-text-size-200);
  line-height: var(--brand-text-lineHeight-200);
}

/* Gridline variant */

.FAQGroup__tablist--gridline {
  padding-inline-start: var(--base-size-48);
  padding-block: var(--base-size-80);
}

.FAQGroup__content--gridline {
  border-inline-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  padding-inline: var(--base-size-64);
  padding-block-start: var(--base-size-80);
  padding-block-end: var(--base-size-96);
}

@media (forced-colors: active) {
  .FAQGroup__tablist-button[aria-selected='true'] {
    border-color: Highlight;
    border-width: var(--brand-borderWidth-thicker);
    color: HighlightText;
  }
}

.FAQGroup__heading {
  padding-inline: var(--base-size-20);
}

/* Custom tablet breakpoint */
@media screen and (min-width: 618px) {
  .FAQGroup__gridline-wrapper {
    border-block-end: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }

  .FAQGroup__accordion {
    margin-block-start: 0;
    max-width: 618px;
    margin-inline: auto;
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
  .FAQGroup__heading {
    max-width: 618px;
    margin: 0 auto;
  }

  .FAQGroup__heading-wrapper {
    padding-block-end: var(--base-size-40);
  }
  .FAQGroup__heading-wrapper--gridline {
    border-block-end: var(--brand-color-border-muted) var(--brand-borderWidth-thin) solid;
  }

  .FAQGroup__accordion--gridline:first-child summary {
    border-block-start: none !important;
  }

  .FAQGroup__accordion--gridline:last-child summary {
    border-block-end: none !important;
  }
}

@media screen and (min-width: 63.25rem) {
  .FAQGroup {
    display: grid;
  }

  .FAQGroup__accordion {
    display: none;
  }

  .FAQGroup__heading {
    padding-inline: 0;
    max-width: 100%;
  }

  .FAQGroup__heading-wrapper--gridline .FAQGroup__heading {
    padding-inline-start: var(--base-size-44);
  }

  .FAQGroup__heading-wrapper {
    padding-block-end: var(--base-size-64);
  }
}

@media screen and (min-width: 80rem) {
  .FAQGroup__tablist--gridline {
    border-inline-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }

  .FAQGroup__content--gridline {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
}
